var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        { staticClass: "pt-3" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-1",
                      staticStyle: { width: "100%" },
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.accordion1",
                                  modifiers: { accordion1: true }
                                }
                              ],
                              attrs: {
                                block: "",
                                href: "#",
                                variant: "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Search Criteria\n            "
                              ),
                              !_vm.showSearch
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-down", size: "lg" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showSearch
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-up", size: "lg" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion1",
                            visible: "",
                            accordion: "accordion1",
                            role: "tabpanel"
                          },
                          model: {
                            value: _vm.showSearch,
                            callback: function($$v) {
                              _vm.showSearch = $$v
                            },
                            expression: "showSearch"
                          }
                        },
                        [
                          !_vm.printing
                            ? _c(
                                "b-row",
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("scoring-event-search", {
                                        attrs: {
                                          skip: {
                                            programme: true,
                                            year: true
                                          },
                                          multiple: {
                                            region: true,
                                            industry: true
                                          }
                                        },
                                        on: {
                                          "update:customer": function($event) {
                                            _vm.customer = $event
                                          },
                                          "update:industry": function($event) {
                                            _vm.industries = $event
                                          },
                                          "update:country": function($event) {
                                            _vm.country = $event
                                          },
                                          "update:region": function($event) {
                                            _vm.regions = $event
                                          },
                                          "update:gear": function($event) {
                                            _vm.gear = $event
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-container",
                                        [
                                          _c(
                                            "b-card",
                                            [
                                              _c("h4", [_vm._v("GPC Session")]),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "date" } },
                                                    [_vm._v("Date")]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("datepicker", {
                                                    attrs: {
                                                      id: "date",
                                                      "disabled-dates": {
                                                        from: new Date()
                                                      },
                                                      "clear-button": true
                                                    },
                                                    model: {
                                                      value: _vm.from_date,
                                                      callback: function($$v) {
                                                        _vm.from_date = $$v
                                                      },
                                                      expression: "from_date"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pl-2 pr-2"
                                                    },
                                                    [_vm._v("to")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("datepicker", {
                                                    attrs: {
                                                      id: "date",
                                                      "disabled-dates": {
                                                        from: new Date()
                                                      },
                                                      "clear-button": true
                                                    },
                                                    model: {
                                                      value: _vm.to_date,
                                                      callback: function($$v) {
                                                        _vm.to_date = $$v
                                                      },
                                                      expression: "to_date"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "date" } },
                                                    [_vm._v("Person")]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("b-form-input", {
                                                    staticClass: "mb-3",
                                                    attrs: {
                                                      placeholder: "Name....",
                                                      id: "person"
                                                    },
                                                    model: {
                                                      value: _vm.partial_name,
                                                      callback: function($$v) {
                                                        _vm.partial_name = $$v
                                                      },
                                                      expression: "partial_name"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Keywords")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _c("vue-tags-input", {
                                                        attrs: {
                                                          tags: _vm.keywords,
                                                          placeholder:
                                                            "Add keywords..."
                                                        },
                                                        on: {
                                                          "tags-changed": function(
                                                            newTags
                                                          ) {
                                                            return (_vm.keywords = newTags)
                                                          }
                                                        },
                                                        model: {
                                                          value: _vm.keyword,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.keyword = $$v
                                                          },
                                                          expression: "keyword"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass:
                                                    "text-center pt-2"
                                                },
                                                [
                                                  _c(
                                                    "b-col",
                                                    [
                                                      _c("toggle-button", {
                                                        attrs: {
                                                          id: "keywordIsAnd",
                                                          labels: {
                                                            checked:
                                                              "Match ALL keywords",
                                                            unchecked:
                                                              "Match ANY keywords"
                                                          },
                                                          width: 150,
                                                          height: 40,
                                                          "switch-color": {
                                                            checked: "#0069D9",
                                                            unchecked: "#218838"
                                                          },
                                                          color: {
                                                            checked: "#278fff",
                                                            unchecked: "#30c651"
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.keywordIsAnd,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.keywordIsAnd = $$v
                                                          },
                                                          expression:
                                                            "keywordIsAnd"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "pt-3 pb-3" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-center" },
                                [
                                  !_vm.searching
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "success" },
                                          on: {
                                            click: function($event) {
                                              _vm.search()
                                            }
                                          }
                                        },
                                        [_vm._v("Search")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      model: {
                        value: _vm.tabIndex,
                        callback: function($$v) {
                          _vm.tabIndex = $$v
                        },
                        expression: "tabIndex"
                      }
                    },
                    [
                      !_vm.printing
                        ? _c("b-tab", { attrs: { title: "Results" } }, [
                            !_vm.searching
                              ? _c(
                                  "div",
                                  [
                                    _vm.results
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "table table-striped"
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Customer")]
                                                ),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Gear")]),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Session")]
                                                ),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Problem")]),
                                                _vm._v(" "),
                                                _c("th")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              [
                                                _vm._l(_vm.results, function(
                                                  item
                                                ) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key: item.id,
                                                      staticClass: "c"
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.customer
                                                                  .name
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.customer
                                                                  .country
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          item.customer.region
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.customer
                                                                  .region
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.customer
                                                                  .industry
                                                              ) +
                                                              " \n                    "
                                                          ),
                                                          item.customer
                                                            .secondary_industry
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.customer
                                                                  .secondary_industry
                                                              ) +
                                                              " \n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(item.gear)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "moment"
                                                                )(
                                                                  item.session_date,
                                                                  "dddd, MMMM Do YYYY"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    Coach: " +
                                                              _vm._s(
                                                                item.coach_name
                                                              ) +
                                                              " \n                    "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    Owner: " +
                                                              _vm._s(
                                                                item.responsible_name
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              item.problem
                                                            )
                                                          }
                                                        })
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        [
                                                          _c(
                                                            "b-button-group",
                                                            {
                                                              attrs: {
                                                                vertical: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "secondary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.session = item
                                                                      _vm.tabIndex = 1
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("View")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.$emit(
                                                                        "edit-gpc",
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("Edit")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "vue-confirmation-button",
                                                                {
                                                                  ref:
                                                                    "deleteButton",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    css:
                                                                      "btn btn-danger sm",
                                                                    messages: [
                                                                      "Delete",
                                                                      "Are you sure?",
                                                                      "Deleted, reloading....."
                                                                    ]
                                                                  },
                                                                  on: {
                                                                    "confirmation-success": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.deleteItem(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }),
                                                _vm._v(" "),
                                                !_vm.total
                                                  ? _c(
                                                      "tr",
                                                      { staticClass: "c" },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            attrs: {
                                                              colspan: "100"
                                                            }
                                                          },
                                                          [_vm._v("No results")]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.total > 0
                                      ? _c("b-pagination", {
                                          attrs: {
                                            size: "sm",
                                            "total-rows": _vm.total,
                                            "per-page": _vm.pageSize
                                          },
                                          model: {
                                            value: _vm.page,
                                            callback: function($$v) {
                                              _vm.page = $$v
                                            },
                                            expression: "page"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.session
                        ? _c("b-tab", { attrs: { title: "Session View" } }, [
                            _c(
                              "div",
                              { attrs: { id: "gpc-session-view" } },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "mb-5" },
                                  [
                                    _c("b-col", { attrs: { cols: "4" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", [
                                      _c(
                                        "span",
                                        { staticClass: "align-bottom" },
                                        [
                                          _c("b-img", {
                                            attrs: {
                                              center: "",
                                              fluid: "",
                                              src: "/static/traction.png"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "4" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pb-2 text-center" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { staticClass: "text-left" }, [
                                      _c(
                                        "h2",
                                        { staticClass: "gpc-title text-left" },
                                        [
                                          _vm._v(
                                            "Record of Group Performance Coaching (GPC) session"
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pb-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { staticClass: "text-left" }, [
                                      _vm._v(
                                        "\n                This is completed by the coach during the session and given to the problem owner to follow up.\n              "
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom",
                                        attrs: { cols: "2" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Company:  \n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.session.customer.name) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom",
                                        attrs: { cols: "2" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Date of session: \n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.session.session_date,
                                                "Do MMMM YYYY"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom",
                                        attrs: { cols: "2" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Problem owner:\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.session.responsible_name
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.session.responsible_role
                                            ) +
                                            ")\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom",
                                        attrs: { cols: "2" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                GPC Coach:\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left border-bottom"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.session.coach_name) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border",
                                        attrs: { cols: "1" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "verticaltext" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "verticaltext_content1"
                                              },
                                              [_vm._v("Group Members")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { staticClass: "text-left border" },
                                      [
                                        _c("div", {
                                          staticClass: "pt-2 pr-2 pb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.session.participants
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border",
                                        attrs: { cols: "1" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "verticaltext w-50" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "verticaltext_content2"
                                              },
                                              [_vm._v("Problem")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { staticClass: "text-left border" },
                                      [
                                        _c("div", {
                                          staticClass: "pt-2 pr-2 pb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.session.problem
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border",
                                        attrs: { cols: "1" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "verticaltext" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "verticaltext_content3"
                                              },
                                              [_vm._v("Actions")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { staticClass: "text-left border" },
                                      [
                                        _c("div", {
                                          staticClass: "pt-2 pr-2 pb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.session.actions
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "pt-3" },
                                  [
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left",
                                        staticStyle: { "font-weight": "bold" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                NEXT STEP -  "
                                        ),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.session.next_step
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "1" } }, [
                                      _vm._v(" ")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-5 pb-5 text-right" },
                    [
                      _vm.session
                        ? _c(
                            "b-button",
                            {
                              staticClass: "align-self-right",
                              on: {
                                click: function($event) {
                                  _vm.print()
                                }
                              }
                            },
                            [_vm._v("Print")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ca39e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ca39e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GPCSearch.vue
// module id = null
// module chunks = 